import React from 'react';
import { observer } from 'mobx-react';
import UnscheduleButton from '../VisitActionButtons/UnscheduleButton/index';
import ScheduleButton from '../VisitActionButtons/ScheduleButton/index';
import { ButtonTypes } from '../../shared/ActionButton/index';
import { useStore } from '../../../store/mst';

interface Props {
  allowAssign?: boolean;
  allowOptimize?: boolean;
}

const OrderDetailsPanelFooter: React.FC<Props> = ({ allowAssign = false, allowOptimize = false }) => {
  const { ui, sortedRoutes } = useStore();
  const { selectedVisit } = ui;

  const routes = sortedRoutes.filter((route) => !route.finished);
  const enableScheduleAndUnschedule = allowAssign && allowOptimize;

  if (!selectedVisit) {
    return null;
  }

  return (
    <>
      <UnscheduleButton
        v5
        v5Hierarchy="tertiary"
        type={ButtonTypes.TEXT_BUTTON}
        orders={[selectedVisit]}
        hasPermission={enableScheduleAndUnschedule}
      />
      <ScheduleButton
        v5
        v5Hierarchy="secondary"
        type={ButtonTypes.TEXT_BUTTON}
        orders={[selectedVisit]}
        routes={routes}
        hasPermission={enableScheduleAndUnschedule}
      />
    </>
  );
};

export default observer(OrderDetailsPanelFooter);
